import { C, fonts } from "../theme.js";
import { ArrowMark, ClippedBtn } from "./primitives.jsx";

export const Nav = ({ accent }) => (
  <nav
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 50,
      padding: "20px 40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: "rgba(10,10,10,0.55)",
      backdropFilter: "blur(14px)",
      WebkitBackdropFilter: "blur(14px)",
      borderBottom: `1px solid ${C.border}`,
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <ArrowMark size={22} accent={accent} />
      <span
        style={{
          fontFamily: fonts.serif,
          fontSize: 22,
          color: C.fg,
          fontWeight: 500,
          letterSpacing: "0.01em",
        }}
      >
        Punta Tech
      </span>
    </div>
    <div
      style={{
        display: "flex",
        gap: 32,
        fontFamily: fonts.mono,
        fontSize: 11,
        letterSpacing: "0.2em",
        color: C.body,
      }}
    >
      <a href="#services" style={{ color: "inherit", textDecoration: "none" }}>SERVICES</a>
      <a href="#about" style={{ color: "inherit", textDecoration: "none" }}>ABOUT</a>
      <a href="#stack" style={{ color: "inherit", textDecoration: "none" }}>EXPERTISE</a>
      <a href="#contact" style={{ color: "inherit", textDecoration: "none" }}>CONTACT</a>
    </div>
    <ClippedBtn filled accent={accent} href="#contact">LET'S TALK ↗</ClippedBtn>
  </nav>
);
